import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import Routes from "./routes";
import moment from "moment";
import Vuetify from "vuetify";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import * as VueGoogleMaps from "vue2-google-maps";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";

import { store } from "./store/store";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCoffee,
  faPencilAlt,
  faTrash,
  faSortUp,
  faSortDown,
  faPlus
} from "@fortawesome/free-solid-svg-icons";
import FlagIcon from "vue-flag-icon";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import i18n from "./i18n";
import "./assets/css/clockit.css";

library.add(faCoffee, faPencilAlt, faTrash, faSortUp, faSortDown, faPlus);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Vuetify);
Vue.use(VueMaterial);
Vue.use(VueRouter);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBGYNGb8F89zlamE0_Kmi7FxYzQYAXoTBY",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
}),
  Vue.use(FlagIcon);

const axios = require("axios");
const router = new VueRouter({
  routes: Routes,
  mode: "history"
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang;

  if (!i18n.availableLocales.includes(lang)) return next("en");

  if (i18n.locale !== lang) {
    i18n.locale = lang;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        name: "login"
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    next();
  } else {
    next();
  }
});

Vue.filter("uppercase", function(value) {
  return value.toUpperCase();
});

Vue.filter("formatDate", function(value) {
  return moment(String(value)).format("YYYY-MM-DD");
});

Vue.filter("formatUxDate", function(value) {
  return moment.unix(value).format("YYYY-MM-DD");
});

Vue.filter("formatUxTime", function(value) {
  return moment.unix(value).format("h:mm:ss A");
});

Vue.filter("formatUx24Time", function(value) {
  return moment.unix(value).format("HH:mm:ss");
});

Vue.filter("formatUxDateTime", function(value) {
  return moment.unix(value).format("YYYY-MM-DD h:mm:ss A");
});

Vue.filter("formatUx24DateTime", function(value) {
  return moment.unix(value).format("YYYY-MM-DD HH:mm:ss");
});

Vue.filter("toggleIsEnabled", function(value) {
  if (value === 0) {
    return "Y";
  } else {
    return "N";
  }
});

Vue.filter("toggleYN", function(value) {
  if (value === 1) {
    return "Y";
  } else {
    return "N";
  }
});

Vue.filter("toggleInOut", function(value) {
  if (value === 1) {
    return "IN";
  } else {
    return "OUT";
  }
});

new Vue({
  el: "#app",
  router: router,
  i18n,
  store: store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js